// Shared design tokens for the auth pages (login / signup / password flows).
// These are intentionally kept local to the auth screens so the new visual
// identity does not affect the rest of the dashboard theme.

export const AUTH_COLORS = {
  marketingBg: '#F8F8F8',
  green: '#53C295',
  greenDark: '#46AC83',
  greenSoft: '#A9E0C7',
  navy: '#1E3878',
  black: '#000000',
  white: '#FFFFFF',
  fieldBorder: '#E6E8EC',
  fieldBorderFocus: '#53C295',
  label: '#1E3878',
  placeholder: '#9AA3B2',
  textMuted: '#6B7280',
};

// Marketing carousel placeholder slides. Swap `image` with the real assets
// once they are provided (drop them under /public/assets/marketing/).
export interface AuthSlide {
  id: string;
  headingKey: string;
  headingFallback: string;
  image?: string;
}

export const AUTH_SLIDES: AuthSlide[] = [
  {
    id: 'chat',
    headingKey: 'auth.slideChat',
    headingFallback: 'سهّلنا كل اللي تحتاجه في منصة وحدة',
    image: '/assets/oneplatform.svg',
  },
  {
    id: 'meeting',
    headingKey: 'auth.slideMeeting',
    headingFallback: 'إبدأ إجتماعك الأول مع المحاسب',
    image: '/assets/book_first_meeting.svg',
  },
  {
    id: 'tasks',
    headingKey: 'auth.slideTasks',
    headingFallback: 'تابع مهامك وفواتيرك وبياناتك المالية',
    image: '/assets/track_tasks.svg',
  },
  {
    id: 'reports',
    headingKey: 'auth.slideReports',
    headingFallback: 'أصدرنا أكثر من +7,500 تقرير',
    image: '/assets/reports.svg',
  },
];
